import {ServiceRequest} from "src/utils/service-request"
import {MOTOR_CADASTRO_OCR_PATH, MOTOR_CADASTRO_PATH, MOTOR_CADASTRO_TEMPORARIO_PATH, MOTOR_CADASTRO_CARACTERISTICAS_PATH} from "../utils/api-routes"

class MotorService {
    constructor() {
        this.request = new ServiceRequest()
    }

    async loadCadastros(cetip, versao) {
        const params = new URLSearchParams()

        if (cetip) params.append("CETIP", cetip)
        if (versao) params.append("VersaoDocumento", versao)

        const query = params.toString() ? `?${params.toString()}` : ""

        return this.request.get(`${MOTOR_CADASTRO_PATH}${query}`)
    }

    async loadCadastrosEventos(cetip, versao) {
            const params = new URLSearchParams()
   
            if (cetip) params.append("CETIP", cetip)
            if (versao) params.append("VersaoDocumento", versao)
            params.append("origem", "PRODUCAO")
            const query = params.toString() ? `?${params.toString()}` : ""
   
            return this.request.get(`${MOTOR_CADASTRO_PATH}${query}`)
    }

    async loadCadastrosOCR(source) {
        return this.request.get(`${MOTOR_CADASTRO_OCR_PATH}?Origem=${source}`)
    }

    async deleteCadastroOCR(ocrId) {
        return this.request.delete(`${MOTOR_CADASTRO_OCR_PATH}/${ocrId}`)
    }

    async createCadastroTemporario(payload) {
        return this.request.post(MOTOR_CADASTRO_TEMPORARIO_PATH, payload)
    }

    async updateCadastroTemporario(cetip, versaoDocumento, payload) {
        const params = new URLSearchParams({
            CETIP: cetip,
            VersaoDocumento: versaoDocumento
        })

        return this.request.put(
            `${MOTOR_CADASTRO_TEMPORARIO_PATH}?${params.toString()}`,
            payload
        )
    }

    async getCadastroTemporario(cetip, versaoDocumento) {
        const params = new URLSearchParams({
            CETIP: cetip,
            VersaoDocumento: versaoDocumento
        })

        return this.request.get(
            `${MOTOR_CADASTRO_TEMPORARIO_PATH}?${params.toString()}`
        )
    }

    async createCadastro(payload) {
        return this.request.post(MOTOR_CADASTRO_PATH, payload)
    }

    async deleteCadastroTemporario(cetip, versaoDocumento) {
        const params = new URLSearchParams({
            CETIP: cetip,
            VersaoDocumento: versaoDocumento
        })

        return this.request.delete(
            `${MOTOR_CADASTRO_TEMPORARIO_PATH}?${params.toString()}`
        )
    }

    async getCadastro(id) {
        const safeId = encodeURIComponent(id)
        const path = `${MOTOR_CADASTRO_PATH}/${safeId}`
        return this.request.get(path)
    }

    async getCadastroCovenants(id) {
        const safeId = encodeURIComponent(id)
        const path = `${MOTOR_CADASTRO_PATH}/${safeId}/covenants`
        return this.request.get(path)
    }

    async createCadastroCovenant(id, payload) {
        const safeId = encodeURIComponent(id)
        const path = `${MOTOR_CADASTRO_PATH}/${safeId}/covenants`
        return this.request.post(path, payload)
    }

    async updateCadastroCovenant(id, covenantId, payload) {
        const safeId = encodeURIComponent(id)
        const safeCovId = encodeURIComponent(covenantId)
        const path = `${MOTOR_CADASTRO_PATH}/${safeId}/covenants/${safeCovId}`
        return this.request.patch(path, payload)
    }

    async deleteCadastroCovenant(id, covenantId) {
        const safeId = encodeURIComponent(id)
        const safeCovId = encodeURIComponent(covenantId)
        const path = `${MOTOR_CADASTRO_PATH}/${safeId}/covenants/${safeCovId}`
        return this.request.delete(path)
    }

    async updateCadastro(id, payload) {
        const safeId = encodeURIComponent(id)
        const path = `${MOTOR_CADASTRO_PATH}/${safeId}`
        return this.request.put(path, payload)
    }

    async updateCadastroCaracteristicas(id, payload){
        const safeId = encodeURIComponent(id)
        const path = `${MOTOR_CADASTRO_CARACTERISTICAS_PATH}/${safeId}`
        return this.request.patch(path, payload)
    }

    async deleteCadastro(id) {
        const safeId = encodeURIComponent(id)
        const path = `${MOTOR_CADASTRO_PATH}/${safeId}`
        return this.request.delete(path)
    }

    async postUploadOcr(formData) {
        const path = `${MOTOR_CADASTRO_PATH}/ocr`
        return this.request.postFormData(path, formData)
    }

    async getCadastroOCR(id) {
        const safeId = encodeURIComponent(id)
        const path = `${MOTOR_CADASTRO_OCR_PATH}/${safeId}/resultado`
        return this.request.get(path)
    }
}

export default MotorService
